var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockChallenges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_260_8447",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 13.9707 13.9707 18 9 18C4.0293 18 0 13.9707 0 9C0 4.0293 4.0293 0 9 0C13.9707 0 18 4.0293 18 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0002 4.72656C9.17922 4.72656 9.3509 4.79768 9.47749 4.92427C9.60408 5.05085 9.67519 5.22254 9.67519 5.40156V8.72256L11.7272 10.7746C11.7935 10.8364 11.8467 10.9109 11.8836 10.9937C11.9205 11.0765 11.9403 11.1659 11.9419 11.2565C11.9435 11.3471 11.9269 11.4372 11.8929 11.5212C11.859 11.6052 11.8084 11.6816 11.7443 11.7457C11.6802 11.8098 11.6039 11.8603 11.5198 11.8943C11.4358 11.9282 11.3458 11.9449 11.2551 11.9433C11.1645 11.9417 11.0751 11.9219 10.9923 11.885C10.9095 11.8481 10.835 11.7949 10.7732 11.7286L8.5232 9.47856C8.39657 9.3521 8.32535 9.18052 8.3252 9.00156V5.40156C8.3252 5.22254 8.39631 5.05085 8.5229 4.92427C8.64949 4.79768 8.82117 4.72656 9.0002 4.72656Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_260_8447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.7998 -1.79688H19.8002V19.8031H-1.7998V-1.79688Z",
    fill: "#214ba5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockChallenges);
export default __webpack_public_path__ + "static/media/clock-challenges.507dae9fb67f0015d1db36875b934468.svg";
export { ForwardRef as ReactComponent };